import { render, staticRenderFns } from "./ProductPipelineSetting.vue?vue&type=template&id=046d43ba&scoped=true&"
import script from "./ProductPipelineSetting.vue?vue&type=script&lang=ts&"
export * from "./ProductPipelineSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.15_vue-template-compiler@2.6.11_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d43ba",
  null
  
)

export default component.exports